import { Logo } from "../../../components/Logo";

export function AutumnInfo() {
  return (
    <div className="max-w-[550px] space-y-6">
      <Logo />
      <p className="text-content-primary text-base leading-relaxed">
        <span className="font-semibold">Automated Revenue Management & Marketing:</span> Our advanced system was built by the industry's best, and handles all revenue management and marketing, so you can focus on what matters most — your guests.
      </p>
      <p className="text-content-primary text-base leading-relaxed">
        <span className="font-semibold">User-Friendly Interface:</span> Get started in just 10 minutes. Enjoy clean, easy-to-understand platform that beautifully displays your performance and how to improve it.
      </p>
      <p className="text-content-primary text-base leading-relaxed">
        <span className="font-semibold">Best-in-Class 24/7 Support:</span> Our AI platform has been trained on the top hotel revenue management and marketing practices. Whether it's about your data or industry insights, just ask Autumn for 24/7 expert assistance.
      </p>
    </div>
  );
}
